import MyAlgoConnect from "@randlabs/myalgo-connect";
import "../components/nftcard/nftcard.css";
import React, { useEffect, useState } from "react";
import TopBar from "../components/header/navbar/TopBar";
import Footer from "../components/footer/Footer";
import { Toast } from "bootstrap";
import { useNavigate } from "react-router-dom"

const algosdk = require("algosdk");
const myAlgoWallet = new MyAlgoConnect();
const Mint = () => {
    const [WalletAddress, setWalletAddress] = useState([]);
    const [params, setParam] = useState("");
    const [temp, setAsets1] = useState("");
    const [assetIDs, setAssetID] = useState(0);
    const [AssetName, setAssetName] = useState("");
    const [UnitName, setUnitName] = useState("");
    const [AssetURL, setAssetURL] = useState("");
    const [loadingState, setLoadingState] = useState(false);
    const bob = "A4VSTGCF2QDAYKUZLEG6XJTLE6ZFDLGCAXUSYP6C6YD3KI2V3CIDZY6BSE"    //bob
    const alice = "VBMVWMHC5UP3HSZTNOF7DYEALZAAV2LE5UFUL65KOWTV4W3M6KUSJPT6CU"  // alice
    const hamza = "NKQBANAABRQENBLI7MI3YMMTJMDNHWJX6ZVFS3UYPTHXFQ24L5EUBBY52Y"  //hamza
    const qasim = "OMBUHDYH6WO74Y3ZF3PIUOWZFEBB5E74MPDHR2A5FUGYUMA47JB6NESXQA"

    const navigate = useNavigate()
    let note = undefined;
    let addr = WalletAddress;
    let defaultFrozen = false;
    let decimals = 0;
    let totalIssuance = 1;
    let unitName = UnitName;
    let assetName = AssetName;
    let assetURL = AssetURL;
    let assetMetadataHash = "16efaa3924a6fd9d3a4824799a4ac65d";
    let manager = WalletAddress;
    let reserve = undefined;
    let freeze = WalletAddress;
    let clawback = WalletAddress;
    var assetID = 0;
    let rawSignedTxn = 0;
    let confirmedTxn = 0;
    var amount = 0;
    let sender = 0;
    let recipient = 0;
    let revocationTarget = 0;
    let closeRemainderTo = 0;
    const algodClient = new algosdk.Algodv2(
        "",
        "https://node.testnet.algoexplorerapi.io",
        ""
    );
    const forParams = async () => {
        let params = await algodClient.getTransactionParams().do();
        setParam(params);
    };
    const CreateToken = async function () {
        window.scrollTo(0, 0)
        setLoadingState(true)
        console.log("hello");
        const bodyelem = document.getElementsByTagName("BODY")[0];
        bodyelem.style.height = "100%"
        bodyelem.style.margin = "0"
        bodyelem.style.overflow = "hidden"

        try {
            console.log(
                "--------------------------------------------Create Asset FUNCTION--------------------------------------------------"
            );
            // params = await algodClient.getTransactionParams().do();
            let txn = algosdk.makeAssetCreateTxnWithSuggestedParams(
                addr,
                note,
                totalIssuance,
                decimals,
                defaultFrozen,
                manager,
                reserve,
                freeze,
                clawback,
                unitName,
                assetName,
                assetURL,
                assetMetadataHash,
                params
            );
            rawSignedTxn = await myAlgoWallet.signTransaction(txn.toByte());
            console.log(rawSignedTxn);
            const tx = await algodClient.sendRawTransaction(rawSignedTxn.blob).do();
            console.log(tx);
            console.log("Trasaction id: ", tx.txId);
            const ptx = await algosdk.waitForConfirmation(algodClient, tx.txId, 4).then(res => {
                setTimeout(() => {
                    bodyelem.style.overflow = "auto"
                    navigate("/mynfts")
                }, 3000);
            });
            // // Get the new asset's information from the creator account
            assetID = ptx["asset-index"];
            console.log(assetID);
            console.log(typeof (assetID));
            setAsets1(assetID);
            //Get the completed Transaction
            console.log(
                "Transaction " +
                tx.txId +
                " confirmed in round " +
                ptx["confirmed-round"]
            );
        } catch (err) {
            console.log(err);
        }
    };

    const WalletListner = () => {
        if (localStorage.WalletAddress) {
            setWalletAddress(localStorage.WalletAddress);
        }
    };

    useEffect(() => {
        WalletListner();
    }, []);

    useEffect(() => {
        forParams();
    });

    return (
        <>


            {loadingState ? (
                <div className="loader-wrao" style={{ visibility: "visible" }}>
                    <div className="loader"></div>
                </div>) : <></>
            }
            <div className="mynfts minting">

                {/* loading frontend */}

                <TopBar />
                <section className="north-staking ">
                    <div className="container">
                        <div className="row">
                            <div className="section-heading">
                                <h1>Mint your nft</h1>
                            </div>
                            <div className="north-contnet">
                                <label ><span>Name</span>
                                    <input placeholder="Name" type="text" onChange={(e) => setAssetName(e.target.value)} />
                                </label>
                                <label ><span>Unit Name</span>
                                    <input placeholder="Unit Name" type="text" onChange={(e) => setUnitName(e.target.value)} />
                                </label>
                                <label> <span>Asset URL</span>
                                    <input placeholder="Asset URL" type="text" onChange={(e) => setAssetURL(e.target.value)} />
                                </label>
                                <button className="mint-now-btn" onClick={CreateToken}> Mint Now</button>
                            </div>
                        </div>
                    </div>


                </section>

                <Footer />
            </div>
        </>

    );
};

export default Mint;
